import { createElement } from 'react';

const KaizenLogo = () => (
  <svg width="189" height="28" viewBox="0 0 189 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.8262 16.7761H39.2566V21.338L43.369 16.7761H46.3774L42.0458 21.6897C42.4184 22.2191 43.1113 23.2068 44.1176 24.6563C45.1239 26.1024 45.8795 27.1824 46.3774 27.893H43.5431L40.35 23.5052L39.2601 24.7452V27.893H36.8297V16.7761H36.8262Z"
      fill="white"
    />
    <path
      d="M55.6494 27.8894L54.6361 25.4877H50.0711L49.0579 27.8894H46.4707L51.175 16.7761H53.5253L58.2331 27.8894H55.6494ZM52.3623 20.0838L50.9904 23.3098H53.7169L52.3623 20.0838Z"
      fill="white"
    />
    <path d="M61.9285 16.7761H59.498V27.8894H61.9285V16.7761Z" fill="white" />
    <path
      d="M63.9863 27.8894V26.1876L69.6865 18.9256H64.1709V16.7761H73.0083V18.4957L67.3187 25.7293H73.1023V27.8894H63.9863Z"
      fill="white"
    />
    <path
      d="M83.0708 16.7761V18.986H77.6492V21.2776H82.5276V23.3915H77.6492V25.6973H83.2414V27.8894H75.2188V16.7761H83.0708Z"
      fill="white"
    />
    <path
      d="M93.0304 16.7761H95.4609V27.8894H93.0304L87.8387 20.9259V27.8894H85.4082V16.7761H87.6855L93.0304 23.9316V16.7761Z"
      fill="white"
    />
    <path
      d="M109.936 17.746C110.695 18.3927 111.075 19.3875 111.075 20.734C111.075 22.0805 110.688 23.0647 109.915 23.69C109.142 24.3153 107.955 24.6279 106.353 24.6279H104.421V27.8859H102.582V16.7761H106.322C107.972 16.7761 109.177 17.0994 109.936 17.746ZM108.634 22.3328C109.003 21.9349 109.187 21.3522 109.187 20.5848C109.187 19.8174 108.954 19.2738 108.488 18.954C108.018 18.6343 107.286 18.4779 106.29 18.4779H104.421V22.9297H106.555C107.572 22.9297 108.265 22.7307 108.634 22.3328Z"
      fill="white"
    />
    <path d="M113.236 27.8894V16.7761H115.075V26.1095H120.047V27.8894H113.236Z" fill="white" />
    <path
      d="M123.599 25.3634L122.509 27.8894H120.545L125.343 16.7761H127.307L132.105 27.8894H130.141L129.052 25.3634H123.599ZM128.303 23.6296L126.325 19.0499L124.347 23.6296H128.303Z"
      fill="white"
    />
    <path d="M136.872 18.4957V27.8894H135.033V18.4957H131.732V16.7761H140.176V18.4957H136.872Z" fill="white" />
    <path
      d="M144.01 18.5277V21.5796H148.84V23.3134H144.01V27.8894H142.172V16.7761H149.432L149.415 18.5277H144.01Z"
      fill="white"
    />
    <path
      d="M160.697 26.3545C159.597 27.4524 158.235 27.9995 156.616 27.9995C154.997 27.9995 153.636 27.4524 152.535 26.3545C151.435 25.2567 150.885 23.8889 150.885 22.2546C150.885 20.6167 151.435 19.2488 152.535 18.151C153.636 17.0532 154.997 16.506 156.616 16.506C158.235 16.506 159.597 17.0532 160.697 18.151C161.798 19.2488 162.348 20.6167 162.348 22.2546C162.348 23.8924 161.801 25.2603 160.697 26.3545ZM159.35 19.4016C158.604 18.6164 157.696 18.2256 156.616 18.2256C155.537 18.2256 154.624 18.6164 153.883 19.4016C153.141 20.1868 152.769 21.139 152.769 22.2546C152.769 23.3737 153.141 24.3223 153.883 25.1075C154.624 25.8927 155.537 26.2835 156.616 26.2835C157.696 26.2835 158.608 25.8927 159.35 25.1075C160.091 24.3223 160.464 23.3737 160.464 22.2546C160.464 21.1354 160.095 20.1868 159.35 19.4016Z"
      fill="white"
    />
    <path
      d="M173.365 20.3858C173.365 22.2191 172.581 23.3738 171.011 23.8534L173.863 27.893H171.526L168.922 24.1554H166.508V27.893H164.67V16.7761H168.72C170.381 16.7761 171.571 17.0639 172.289 17.6359C173.006 18.2079 173.365 19.1246 173.365 20.3858ZM170.92 21.9597C171.293 21.6329 171.481 21.1035 171.481 20.3787C171.481 19.6539 171.289 19.1565 170.903 18.883C170.52 18.6129 169.834 18.4779 168.845 18.4779H166.508V22.4536H168.8C169.837 22.4536 170.544 22.2901 170.92 21.9597Z"
      fill="white"
    />
    <path
      d="M177.852 27.8894H176.014V16.7761H178.879L182.166 23.7575L185.457 16.7761H188.305V27.8894H186.467V19.2098L182.668 26.9195H181.637L177.852 19.2098V27.8894Z"
      fill="white"
    />
    <path d="M27.3376 22.312H0V27.89H27.3376V22.312Z" fill="white" />
    <path
      d="M24.6007 0H19.1339V2.78899H22.7413L10.286 15.4975L11.8529 17.0928L0 4.99886V8.94608L10.2895 19.4448L12.222 17.4729L12.2185 17.4694L24.6007 4.83543V8.36696H27.3341V2.78899V0H24.6007Z"
      fill="#2DD28D"
    />
  </svg>

  // <svg width="314" height="80" viewBox="0 0 314 80" fill="none" xmlns="http://www.w3.org/2000/svg">
  //   <path
  //     d="M180.391 45.3969C181.464 46.3281 182 47.7608 182 49.7C182 51.6393 181.454 53.0566 180.362 53.9571C179.269 54.8577 177.592 55.308 175.328 55.308H172.598V60H170V44H175.284C177.616 44 179.319 44.4656 180.391 45.3969ZM178.551 52.0026C179.073 51.4295 179.333 50.5903 179.333 49.4851C179.333 48.3799 179.004 47.5971 178.344 47.1366C177.68 46.676 176.647 46.4509 175.24 46.4509H172.598V52.8622H175.614C177.05 52.8622 178.03 52.5756 178.551 52.0026Z"
  //     fill="#4A546A"
  //   />
  //   <path d="M185 60V44H187.699V57.4373H195V60H185Z" fill="#4A546A" />
  //   <path
  //     d="M199.991 56.3632L198.388 60H195.5L202.556 44H205.444L212.5 60H209.612L208.009 56.3632H199.991ZM206.908 53.867L204 47.2737L201.092 53.867H206.908Z"
  //     fill="#4A546A"
  //   />
  //   <path d="M219.304 46.4757V60H216.691V46.4757H212V44H224V46.4757H219.304Z" fill="#4A546A" />
  //   <path
  //     d="M229.659 46.5217V50.9156H236.644V53.4118H229.659V60H227V44H237.5L237.475 46.5217H229.659Z"
  //     fill="#4A546A"
  //   />
  //   <path
  //     d="M254.052 58.1385C252.42 59.7145 250.401 60.5 248 60.5C245.599 60.5 243.58 59.7145 241.948 58.1385C240.316 56.5624 239.5 54.5988 239.5 52.2525C239.5 49.9012 240.316 47.9376 241.948 46.3615C243.58 44.7855 245.599 44 248 44C250.401 44 252.42 44.7855 254.052 46.3615C255.684 47.9376 256.5 49.9012 256.5 52.2525C256.5 54.6039 255.689 56.5675 254.052 58.1385ZM252.054 48.1569C250.949 47.0297 249.601 46.4686 248 46.4686C246.399 46.4686 245.046 47.0297 243.946 48.1569C242.846 49.2841 242.294 50.651 242.294 52.2525C242.294 53.8592 242.846 55.221 243.946 56.3482C245.046 57.4754 246.399 58.0365 248 58.0365C249.601 58.0365 250.954 57.4754 252.054 56.3482C253.154 55.221 253.706 53.8592 253.706 52.2525C253.706 50.6459 253.159 49.2841 252.054 48.1569Z"
  //     fill="#4A546A"
  //   />
  //   <path
  //     d="M272.269 49.1953C272.269 51.8338 271.118 53.4957 268.812 54.186L273 60H269.569L265.744 54.6206H262.2V60H259.5V44H265.447C267.886 44 269.635 44.4142 270.689 45.2375C271.742 46.0607 272.269 47.38 272.269 49.1953ZM268.679 51.4605C269.226 50.9901 269.502 50.2282 269.502 49.185C269.502 48.1419 269.221 47.426 268.653 47.0323C268.091 46.6437 267.084 46.4493 265.631 46.4493H262.2V52.1713H265.565C267.089 52.1713 268.127 51.9361 268.679 51.4605Z"
  //     fill="#4A546A"
  //   />
  //   <path
  //     d="M278.692 60H276V44H280.197L285.01 54.0511L289.829 44H294V60H291.308V47.5038L285.744 58.6036H284.235L278.692 47.5038V60Z"
  //     fill="#4A546A"
  //   />
  //   <path
  //     d="M74 44H77.4353V50.5657L83.2477 44H87.5L81.3775 51.0719C81.9041 51.8338 82.8835 53.2554 84.3059 55.3416C85.7282 57.4228 86.7962 58.9773 87.5 60H83.4938L78.9807 53.6849L77.4402 55.4695V60H74.0049V44H74Z"
  //     fill="#4A546A"
  //   />
  //   <path
  //     d="M100.766 60L99.3014 56.5422H92.7037L91.2392 60H87.5L94.299 44H97.696L104.5 60H100.766ZM96.0151 48.7621L94.0323 53.4066H97.9728L96.0151 48.7621Z"
  //     fill="#4A546A"
  //   />
  //   <path d="M110 44H106.5V60H110V44Z" fill="#4A546A" />
  //   <path d="M113 60V57.5499L121.129 47.0946H113.263V44H125.866V46.4757L117.752 56.89H126V60H113Z" fill="#4A546A" />
  //   <path
  //     d="M141.245 44V47.1816H133.135V50.4808H140.432V53.5243H133.135V56.844H141.5V60H129.5V44H141.245Z"
  //     fill="#4A546A"
  //   />
  //   <path d="M155.373 44H159V60H155.373L147.627 49.9744V60H144V44H147.398L155.373 54.3018V44Z" fill="#4A546A" />
  //   <path d="M60 51.7647H20V60H60V51.7647Z" fill="#4A546A" />
  //   <path
  //     d="M56 20H48V24.0498H53.279L35.0522 42.5036L20 27.2587V32.9904L35.0573 48.2353L37.8853 45.372L37.8803 45.3669L56 27.0214V32.1495H60V24.0498V20H56Z"
  //     fill="#88E18E"
  //   />
  // </svg>
);

export default KaizenLogo;
